import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {CouponInput} from '../../coupon/coupon-input'
import fs from '../../form/form.scss'
import {FormButton} from '../../form-button'
import {FormSteps, Step} from '../../form-steps'
import {Checkout} from '../index'
import {MembershipSelector} from '../membership-selector'
import {ReservationTimer} from '../reservation-timer'
import {CheckoutSummary} from './checkout-summary'
import {CheckoutSummary as CheckoutSummaryOld} from './checkout-summary/old'
import {MobileCheckoutProps} from './interfaces'
import s from './mobile-checkout.scss'

export const MobileCheckout = ({
  formPageLoaded,
  closeNativeModal,
  openTicketsDetailsModal,
  reservationExpiration,
  invoice,
  t,
  isMobile,
  openTimeExpiredModal,
  scrollToElement,
}: MobileCheckoutProps) => {
  const {experiments} = useExperiments()
  const updatedCheckoutSummaryEnabled = experiments.enabled(ExperimentNames.UpdatedCheckoutSummary)

  React.useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()
  }, [formPageLoaded, closeNativeModal])

  const isCheckoutReady = (steps: Step[]) => steps.every(step => step.completed)

  const openTicketDetails = () => openTicketsDetailsModal()

  return (
    <Checkout t={t}>
      {(steps: Step[], currentStep: FormStep, pay: Function) => (
        <div className={classNames(s.container, c.formBackgroundColor)}>
          {updatedCheckoutSummaryEnabled ? (
            <div className={s.stack}>
              <ReservationTimer
                expires={reservationExpiration}
                onExpire={openTimeExpiredModal}
                t={t}
                isMobile={isMobile}
              />
              <CheckoutSummary onViewAllItems={openTicketDetails} currentStep={currentStep} />
            </div>
          ) : (
            <>
              <div className={fs.summaryBlock}>
                <ReservationTimer
                  expires={reservationExpiration}
                  onExpire={openTimeExpiredModal}
                  t={t}
                  isMobile={isMobile}
                />
              </div>
              <CouponInput currentStep={currentStep} />
              <MembershipSelector />
              <CheckoutSummaryOld invoice={invoice} onViewAllItems={openTicketDetails} />
            </>
          )}
          <FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />
          {isCheckoutReady(steps) && Number(invoice?.grandTotal?.amount) > 0 ? (
            <div className={s.button}>
              <FormButton
                text={t('mobile.checkout.placeOrder')}
                type="submit"
                dataHook={DH.CHECKOUT_BUTTON}
                onClick={pay}
              />
            </div>
          ) : null}
        </div>
      )}
    </Checkout>
  )
}
